import React from "react";
import { Typography } from "antd";
import { useTheme } from "../services/useTheme";
import PageHelpDrawer from "./PageHelpDrawer";

export default function PageLayout({
  title,
  logo,
  logoSrc,
  description,
  helpContent,
  children,
}) {
  const isDarkTheme = useTheme();

  let src = logoSrc;
  if (!src && logo) {
    if (logo.endsWith(".svg")) {
      src = isDarkTheme ? logo.replace(".svg", "_white.svg") : logo;
    } else {
      src = `${logo}${isDarkTheme ? "-white" : ""}.png`;
    }
  }

  return (
    <div>
      <div className="page-title-row">
        <Typography.Title level={2} className="page-title">
          {src && (
            <img
              src={src}
              alt="Logo"
              className="page-logo"
              style={{ height: "50px" }}
            />
          )}{" "}
          {title}
        </Typography.Title>
        {helpContent && (
          <PageHelpDrawer helpContent={helpContent} logoSrc={src} />
        )}
      </div>
      {description && (
        <Typography.Paragraph className="page-description">
          {description}
        </Typography.Paragraph>
      )}
      {children}
    </div>
  );
}
